// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21YJh","right":"Footer_right__1E1bz","buttons":"Footer_buttons__2ffJM"};